import { formatNumberWithThousandsSeparator } from '../calculator/_utilities'

const getTotalSavings = (data) => {
  return parseFloat(data[data.length - 1] || 0).toFixed()
}

const calculateTotalInterest = (config, value, from) => {
  // return data.reduce((a, b) => parseFloat(a) + parseFloat(b), 0).toFixed()
  return value - (from + config.currentValues.initial_investment)
}

const updateRatesTable = (config, totalFrom = 0) => {
  const scuTotal = getTotalSavings(config.currentSavings.scu)
  const competitorTotal = getTotalSavings(config.currentSavings.banks)

  const scuInterest = calculateTotalInterest(config, scuTotal, totalFrom)
  const competitorInterest = calculateTotalInterest(config, competitorTotal, totalFrom)

  const profitDifference = (scuInterest - competitorInterest).toFixed()

  const tableEl = config.elements.table
  // Update DOM elements
  tableEl.querySelector('.scu_profit').textContent = formatNumberWithThousandsSeparator(scuInterest)
  document
    .querySelectorAll('.scu_total')
    .forEach((span) => (span.textContent = formatNumberWithThousandsSeparator(scuTotal)))
  tableEl.querySelector('.banks_profit').textContent = formatNumberWithThousandsSeparator(competitorInterest)
  tableEl.querySelector('.banks_total').textContent = formatNumberWithThousandsSeparator(competitorTotal)
  tableEl.querySelector('.diff_profit').textContent = formatNumberWithThousandsSeparator(profitDifference)
}

export { updateRatesTable }
